export default "__VITE_ASSET__DaNwmxBR__"